/**
 * Audit logging — fire-and-forget log of operator actions to the worker.
 *
 * REBUILD NOTE: Original posted to /api/admin/audit with action type, resource
 * IDs, and operator email. Stub for now — wire up when admin/audit route is
 * implemented in the worker.
 */
import type { AuditWriteRequest } from '@parkify/api-types'
import { callApi } from '../config/apiBase'

export type AuditEntry = AuditWriteRequest

export async function logAudit(entry: AuditEntry, headers: HeadersInit): Promise<void> {
  try {
    await callApi(`/api/admin/audit`, {
      method: 'POST',
      headers: { 'content-type': 'application/json', ...(headers as Record<string, string>) },
      body: JSON.stringify({ ...entry, ts: new Date().toISOString() }),
    })
  } catch {
    // best-effort; never block UI on audit failure
  }
}
